<div class="main-navbar">
  <div id="mainnav" class="" 
    (mouseleave)="goAllout()"
  >
    <div class="d-flex align-items-start px-5 position-relative " style="background-color: var(--theme-default);height: 43px;">
      <!-- Brand Link (static) -->
      <a
        [routerLink]="['/elements/trademarks']"
        class="tradLink text-decoration-none mx-3"
        style="white-space: nowrap;"
      >
        <span>
          {{ 'brands' | translate }}
        </span>
      </a>
      <span
        class="tradLink text-decoration-none "
        style="white-space: nowrap;cursor: pointer;"
        (mouseenter)="onHoverIncontainer()"
        (mouseleave)="onHoverOutcontainer()"
      >
        <span>
          {{ 'allCategories' | translate }}
        </span>
        <i class="fa fa-chevron-down"></i>
      </span>
      <!-- Slider Wrapper (hover logic isolated here) -->
      <div
        class="flex-grow-1 overflow-hidden"
        (mouseenter)="onHoverIncontainer()"
        (mouseleave)="onHoverOutcontainer()"
      >
        <ng-container *ngIf="menuItems.length > 0">
          <owl-carousel-o [options]="menuSliderConfig" class="menu-slider" #owlCarousel>
            <ng-container *ngFor="let menuItem of menuItems">
              <ng-template carouselSlide style="height: 100%;">
                <a
                  [routerLink]="['/shop/category/', menuItem.id, menuItem.title?.split(' ').join('-')]"
                  class="owl-link"
                  [class.active]="menuItem.id == activeCatId"
                  [attr.data-target]="menuItem.id"
                  (mouseenter)="onHoverIn(menuItem.id)"
                  (click)="onHoverOutcontainer()"
                >
                  {{ menuItem.title | translate }}
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </ng-container>
      </div>
      <span
        (mouseenter)="onHoverIncontainer()"
        (mouseleave)="onHoverOutcontainer()"
        class="d-flex align-items-center justify-content-center"
        style="padding-block: 5px"
        *ngIf="menuItems.length >= 11"
        >
        <button class="btn" (click)="prev()" [disabled]="sliderIndex == 0">
          <i class="fa fa-chevron-right text-white"></i>
        </button>
        <button class="btn" (click)="next()" [disabled]="sliderIndex == 1">
          <i class="fa fa-chevron-left text-white"></i>
        </button>
      </span>




      <!-- hover content -->
     <div class="backrop position-absolute w-100 vh-100 d-none" style="z-index: 9;" #categoriesContainer >
       <div class="item-content position-absolute start-0 d-flex bg-white"   
       (mouseenter)="onHoverIncontainer();onHoverIn(activeCatId)"
       (mouseleave)="onHoverOutcontainer();"
       > 
         <div class="main-categories w-25" #scrollContainer>
           <div *ngFor="let menuItem of menuItems" class="cat-container"  (mouseenter)="changetradmarkesAnsSubServices(menuItem.id)" >
             <a 
               (click)="onHoverOutcontainer()" 
               [routerLink]="['/shop/category/', menuItem.id , menuItem.title?.split(' ').join('-')]"
               [class.active]="menuItem.id == activeCatId"
               class="text-decoration-none text-dark d-flex justify-content-between align-items-center cat-link" 
             [attr.data-target]="menuItem.id">
               <span>
                 {{ menuItem.title | translate }}
               </span>
               <div class="arrow">
                 <i class="fa fa-angle-left"></i>
               </div>
             </a>
           </div>
         </div>
         <div class="w-50 bg-white trademark-links" >
           <h6>
             الأقسام الفرعية
           </h6>
           <div class="d-flex justify-content-start align-items-start flex-wrap" >
             <a
               class="d-flex flex-column align-items-center text-decoration-none"  
               *ngFor="let  sub of currentSubArr" 
               [routerLink]="['/shop/category/', sub.id , sub.title?.split(' ').join('-')]"
               (click)="onHoverOutcontainer()"
             >
               <img [src]="Commen._ImageUrl + 'services/'+sub.image"  [alt]="sub.title" (error)="handleImage($event)" />
               <span>
                 {{ sub.title | translate }}
               </span>
             </a>
           </div>
         </div>
         <div class="subservices-links bg-white w-25" >
           <h6>
             اشهر الماركات
           </h6>
           <div class="d-flex justify-content-start align-items-start flex-wrap" >
             <a
               class="d-flex flex-column align-items-center text-decoration-none"  
               *ngFor="let tadmark of currentTadmarksArr" 
               [routerLink]="['/shop/trademarkes/', tadmark.id , tadmark.title?.split(' ').join('-')]"
               (click)="onHoverOutcontainer()"
             >
               <img [src]="Commen._ImageUrl + 'trademarks/'+tadmark.image"  [alt]="tadmark.title" (error)="handleImage($event)" />
               <span>
                 {{ tadmark.title | translate }}
               </span>
             </a>
           </div>
         </div>
       </div>
     </div>
    </div>

  </div>
</div>